function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/*
 * Comcast CONFIDENTIAL
 *
 * Copyright 2003 - 2017 Comcast Corporation
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Comcast Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Comcast Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is unlawful and strictly forbidden unless prior written permission is obtained
 * from Comcast Corporation.
 */
//// CONTROLLER ////
export var ManageAirWindowsDialogController =
/*#__PURE__*/
function () {
  _createClass(ManageAirWindowsDialogController, null, [{
    key: "$inject",
    get: function get() {
      return ['$mdDialog', '$scope', '$timeout', 'OrderResourceFactory', 'deliveries'];
    }
  }]);

  function ManageAirWindowsDialogController($mdDialog, $scope, $timeout, OrderResourceFactory, deliveries) {
    _classCallCheck(this, ManageAirWindowsDialogController);

    /* BINDABLE : INJECTS */
    Object.assign(this, {
      $mdDialog: $mdDialog,
      $scope: $scope,
      $timeout: $timeout,
      OrderResourceFactory: OrderResourceFactory,
      deliveries: deliveries
    });
    /* BINDABLE : DATA */

    /* EVENTS */
    //Register any event listeners
  }
  /* IMPLEMENTATION : BINDABLE */


  _createClass(ManageAirWindowsDialogController, [{
    key: "cancel",
    value: function cancel() {
      var vm = this;
      vm.$mdDialog.cancel();
    }
  }, {
    key: "createSettleablePromise",
    value: function createSettleablePromise(delivery) {
      var vm = this;
      return new Promise(function (resolve, reject) {
        vm.OrderResourceFactory.updateFlightDates({
          id: delivery.OrderGroup.DistributionOrder.id
        }, {
          flightStartDate: moment(delivery.selectedStartFlightDate).toISOString(),
          flightEndDate: moment(delivery.selectedEndFlightDate).toISOString()
        }, function () {
          return resolve({
            success: true,
            delivery: delivery
          });
        }, function () {
          return resolve({
            success: false,
            delivery: delivery
          });
        });
      });
    }
  }, {
    key: "submit",
    value: function submit() {
      var vm = this;
      var settledPromises = [];
      vm.loading = true;

      for (var i = 0; i < vm.deliveries.length; i++) {
        settledPromises.push(vm.createSettleablePromise(vm.deliveries[i]));
      }

      Promise.all(settledPromises).then(function complete(responses) {
        var results = {
          success: 0,
          failure: 0
        }; // Loop through responses and  see how many were successful

        for (var x = 0; x < responses.length; x++) {
          if (responses[x].success) {
            results.success++;
          } else {
            results.failure++;
          }
        } // Call hide and pass back whether it was a success or not


        vm.$mdDialog.hide({
          success: results.success,
          failure: results.failure,
          message: results.failure === 0 ? 'All orders were successfully updated' : results.success === 0 ? 'None of the selected orders could be updated' : 'Some of the selected orders could not be updated'
        });
        vm.loading = false;
      });
    }
  }, {
    key: "removeSpot",
    value: function removeSpot(index) {
      var vm = this;
      vm.deliveries.splice(index, 1);
    }
  }, {
    key: "setStartDateRows",
    value: function setStartDateRows() {
      var vm = this;

      if (vm.startDateHeader === null) {
        // Nothing to do here, because no date has been selected
        return;
      }

      for (var i = 0; i < vm.deliveries.length; i++) {
        var dateStack = [];

        if (vm.deliveries[i].Spot && vm.deliveries[i].Spot.runEndDate) {
          dateStack.push(moment(vm.deliveries[i].Spot.runEndDate));
        }

        dateStack.push(moment(vm.startDateHeader));
        var findMaxStack = [];
        findMaxStack.push(moment.min(dateStack).hour(0).minute(0).second(0).format());

        if (vm.deliveries[i].Spot && vm.deliveries[i].Spot.runStartDate) {
          findMaxStack.push(moment(vm.deliveries[i].Spot.runStartDate));
        } // Don't let the date go BEFORE the spot asset's start date


        vm.deliveries[i].selectedStartFlightDate = moment.max(findMaxStack);

        if (vm.deliveries[i].selectedEndFlightDate !== undefined) {
          if (moment(vm.deliveries[i].selectedEndFlightDate).isBefore(moment(vm.deliveries[i].selectedStartFlightDate))) {
            vm.deliveries[i].selectedEndFlightDate = vm.deliveries[i].selectedStartFlightDate;
          }
        }
      }
    }
  }, {
    key: "setEndDateRows",
    value: function setEndDateRows() {
      var vm = this;

      if (vm.endDateHeader === null) {
        // Nothing to do here, because no date has been selected
        return;
      }

      for (var i = 0; i < vm.deliveries.length; i++) {
        var dateStack = [];

        if (vm.deliveries[i].Spot && vm.deliveries[i].Spot.runEndDate) {
          dateStack.push(moment(vm.deliveries[i].Spot.runEndDate));
        }

        dateStack.push(moment(vm.endDateHeader));
        vm.deliveries[i].selectedEndFlightDate = moment.min(dateStack).hour(0).minute(0).second(0).format();
      }
    }
  }, {
    key: "findStartDateRow",
    value: function findStartDateRow(index) {
      var vm = this;
      vm.startDateRow = vm.deliveries[index];
    }
  }, {
    key: "clearStartHeader",
    value: function clearStartHeader() {
      var vm = this;
      vm.startDateHeader = null;
    }
  }, {
    key: "clearEndHeader",
    value: function clearEndHeader() {
      var vm = this;
      vm.endDateHeader = null;
    }
    /* IMPLEMENTATION : PRIVATE */
    // All private methods should start with '_' in order to distinguish them

    /* INITIALIZATION */

  }, {
    key: "$onInit",
    value: function $onInit() {
      // Method-wide declarations
      var vm = this;
      vm.bowser = bowser; // Handle date filters in $scope to prevent `this` lossage

      vm.$scope.endDateHeaderFilter = function (date) {
        if (vm.startDateHeader !== undefined) {
          return moment(date).isSameOrAfter(moment().subtract(1, 'd')) && moment(date).isSameOrAfter(moment(vm.startDateHeader).add(1, 'd'));
        } else {
          return moment(date).isSameOrAfter(moment().subtract(1, 'd'));
        }
      };

      vm.$scope.startDateHeaderFilter = function (date) {
        return moment(date).isSameOrAfter(moment().subtract(1, 'd'));
      };

      vm.$scope.endDateRowFilter = function (date) {
        var prelimCheck = true;

        if (vm.startDateRow && vm.startDateRow.selectedStartFlightDate) {
          prelimCheck = moment(date).isSameOrAfter(moment().subtract(1, 'd')) && moment(date).isSameOrAfter(moment(vm.startDateRow.selectedStartFlightDate).add(1, 'd'));
        } else {
          prelimCheck = moment(date).isSameOrAfter(moment().subtract(1, 'd'));
        }

        if (vm.startDateRow && vm.startDateRow.Spot.runStartDate) {
          prelimCheck = prelimCheck && moment(date).isSameOrAfter(moment(vm.startDateRow.Spot.runStartDate));
        }

        if (vm.startDateRow && vm.startDateRow.Spot.runEndDate) {
          prelimCheck = prelimCheck && moment(date).isSameOrBefore(moment(vm.startDateRow.Spot.runEndDate));
        }

        return prelimCheck;
      };

      vm.$scope.startDateRowFilter = function (date) {
        var prelimCheck = true;

        if (vm.startDateRow && vm.startDateRow.selectedEndFlightDate) {
          prelimCheck = moment(date).isSameOrAfter(moment().subtract(1, 'd')) && moment(date).isSameOrBefore(moment(vm.startDateRow.selectedEndFlightDate));
        } else {
          prelimCheck = moment(date).isSameOrAfter(moment().subtract(1, 'd'));
        }

        if (vm.startDateRow && vm.startDateRow.Spot.runStartDate) {
          prelimCheck = prelimCheck && moment(date).isSameOrAfter(moment(vm.startDateRow.Spot.runStartDate));
        }

        return prelimCheck;
      }; // Smooth sizing for the resizable directive


      var cancelSizing = vm.$scope.$watch(function () {
        var testHeader = document.getElementsByClassName('sizable-header')[0];

        if (testHeader && angular.element(testHeader) && angular.element(testHeader)[0]) {
          return angular.element(testHeader)[0].clientWidth;
        } else {
          return 0;
        }
      }, function (oldVal, newVal) {
        vm.$timeout(function () {
          // Set the flex-basis on all resizable headers
          var headers = document.getElementsByClassName('sizable-header');

          for (var i = 0; i < headers.length; i++) {
            if (!vm.bowser.msie) {
              angular.element(headers[i]).css('flex-basis', angular.element(headers[i])[0].clientWidth);
            } else {
              angular.element(headers[i]).css('width', angular.element(headers[i])[0].clientWidth);
            }
          }
        });
      }, true);
      vm.$scope.$on('angular-resizable.resizing', function (event, args) {
        // Set the flex-basis on all resizable headers
        var headers = document.getElementsByClassName('sizable-header');

        for (var i = 0; i < headers.length; i++) {
          if (!vm.bowser.msie) {
            angular.element(headers[i]).css('flex-basis', angular.element(headers[i])[0].clientWidth);
          } else {
            angular.element(headers[i]).css('width', angular.element(headers[i])[0].clientWidth);
          }
        }

        if (cancelSizing) {
          cancelSizing();
          cancelSizing = null;
        }
      });
    }
  }]);

  return ManageAirWindowsDialogController;
}();